import React from 'react';
import _ from 'lodash';
import globalStore from '@/stores';
import './assets/less/index.scoped.less';

export const getWatermarkUrl = (content: string) => {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  canvas.style.display = 'none';
  if (ctx) {
    const left = 30;
    const top = 30;
    const fontSize = 20;
    ctx.font = `${fontSize}px sans-serif`;
    const contentWidth = ctx.measureText(content).width;
    const width = contentWidth + left * 2 ;
    const height = contentWidth + top * 2;
    canvas.width = width;
    canvas.height = height;

    const x = width / 2;
    const y = height / 2;

    ctx.save();
    ctx.translate(x, y);
    ctx.rotate((-45 * Math.PI) / 180);
    ctx.translate(-x, -y);
    ctx.fillStyle = 'rgba(147, 149, 153, 0.1)';
    ctx.font = `${fontSize}px sans-serif`;
    ctx.textAlign = 'left';
    ctx.textBaseline = 'top';
    ctx.fillText(content, left, (height - fontSize) / 2);
    ctx.restore();
    return canvas.toDataURL('image/png', 1);
  }
  return '';
};

export const Watermark: React.FC = (props) => {
  const { login_type, user_id: _user_id, operator_name = '', saleStatus = {} } = globalStore.account;
  const { userId = '' } = saleStatus as any;
  const user_id = _user_id || userId;
  const content = login_type === 3 ? operator_name : `${operator_name} ${user_id}`;
  const watermarkUrl = getWatermarkUrl(content);

  return (
    <div
      className="watermark"
      style={{
        backgroundImage: `url(${watermarkUrl})`,
      }}
    ></div>
  );
};

export default Watermark;
